import { WIZARD_CLEAN_DATA, WIZARD_SET_SECTION, WIZARD_UPDATE_DATA } from '../actions/types';

export const initialState = {
  section: '',
  subSection: '',
  data: {},
};

export const wizard = (state = initialState, action) => {
  switch (action.type) {
    case WIZARD_SET_SECTION: {
      if (action.payload.section) state.section = action.payload.section;
      if (action.payload.subSection) state.subSection = action.payload.subSection;
      return state;
    }
    case WIZARD_CLEAN_DATA: {
      state.data = {};
      return state;
    }
    case WIZARD_UPDATE_DATA: {
      state.data = { ...state.data, ...action.payload };
      return state;
    }
    default:
      return state;
  }
};
